module.exports = __webpack_public_path__ + "img/h_gardenia_main.jpg";